import './index.css';
import { useState, useRef, useCallback } from 'react';
import { add, sub } from 'date-fns';

const DATE_STEP_BY_CALENDAR = {
    day: { months: 1 },
    month: { years: 1 },
    year: { years: 12 },
};
const useDatePickerControls = (enabledCalendars, displayDate, onDisplayDateChange) => {
    const [calendar, setCalendar] = useState(enabledCalendars.startsWith('dd') ? 'day' : 'month');
    const prevCalendarRef = useRef(null);
    const switchCalendar = useCallback(() => {
        if (calendar === 'day') {
            setCalendar('month');
        }
        if (calendar === 'month') {
            const startsWithDay = enabledCalendars.startsWith('dd');
            const endsWithYear = enabledCalendars.endsWith('yyyy');
            if (startsWithDay && endsWithYear) {
                setCalendar(prevCalendarRef.current !== 'day' ? 'day' : 'year');
            }
            if (startsWithDay && !endsWithYear) {
                setCalendar('day');
            }
            if (!startsWithDay && endsWithYear) {
                setCalendar('year');
            }
        }
        if (calendar === 'year') {
            setCalendar('month');
        }
        prevCalendarRef.current = calendar;
    }, [enabledCalendars, calendar, setCalendar]);
    const zoomIntoMonth = useCallback((value) => {
        if (value) {
            onDisplayDateChange?.(value);
            prevCalendarRef.current = 'month';
            setCalendar('day');
        }
    }, [onDisplayDateChange, setCalendar]);
    const zoomIntoYear = useCallback((value) => {
        if (value) {
            onDisplayDateChange?.(value);
            prevCalendarRef.current = 'year';
            setCalendar('month');
        }
    }, [onDisplayDateChange, setCalendar]);
    const goToNextPeriod = useCallback(() => {
        onDisplayDateChange?.(add(displayDate, DATE_STEP_BY_CALENDAR[calendar]));
    }, [calendar, displayDate, onDisplayDateChange]);
    const goToPrevPeriod = useCallback(() => {
        onDisplayDateChange?.(sub(displayDate, DATE_STEP_BY_CALENDAR[calendar]));
    }, [calendar, displayDate, onDisplayDateChange]);
    return { calendar, switchCalendar, zoomIntoMonth, zoomIntoYear, goToNextPeriod, goToPrevPeriod };
};

export { useDatePickerControls };
//# sourceMappingURL=useDatePickerControls.js.map
